import { useSelector } from "react-redux";
import { graphql, useLazyLoadQuery } from "react-relay";

import { getOrgUuid } from "state/current_user/selectors";

import type { useOrgDataLevelQuery } from "__generated__/useOrgDataLevelQuery.graphql";

export const organizationDataLevelQuery = graphql`
  query useOrgDataLevelQuery($orgUuid: String!, $skip: Boolean!) {
    organization(uuid: $orgUuid) @skip(if: $skip) {
      id
      dataLevel
    }
  }
`;

export const useOrgDataLevel = () => {
  const orgUuid = useSelector(getOrgUuid);
  const data = useLazyLoadQuery<useOrgDataLevelQuery>(organizationDataLevelQuery, {
    orgUuid,
    skip: !orgUuid,
  });
  return data?.organization?.dataLevel;
};

export const useIsCjisOrgReady = () => {
  // Add a hook for exposing CJIS datalevel to UI in org managment
  // Could probably be done a better way but this is an abstracted way of doing it
  return false;
};
